let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("Nd8Dq")).then(() => parcelRequire('64AA8'));